<template>
  <div class="labeled-pets-list">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <PetsList
      ref="petsList"
      :id="inputId"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :pet="pet"
      :pets="pets"
      :empty-state-text="emptyStateText"
      :select-first-pet="selectFirstPet"
      @beforeChange="onBeforeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </PetsList>
  </div>
</template>

<script>
import PetsList from '../pets-list';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: 'Оберіть тварину клієнта зі списку',
    },
    placeholder: {
      type: String,
      default: 'Оберіть тварину',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    pet: {
      type: [String, Number, null],
      default: null,
    },
    pets: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    selectFirstPet: {
      type: Boolean,
      default: true,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      inputId: `pets-list-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, PetsList },
  computed: {
    getPetsList() {
      return this.$refs.petsList;
    }
  },
  methods: {
    generateRandomId,
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
};
</script>